module.exports = __webpack_public_path__ + "static/media/welcomMM_img.c9802a1b.png";